import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { authApi } from '../services/apiAuth';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = authApi.getStoredUser();
    const token = authApi.getStoredToken();
    if (storedUser && token) {
      setUser(storedUser);
      let settled = false;
      const finish = () => {
        if (settled) return;
        settled = true;
        setLoading(false);
      };
      const timer = setTimeout(finish, 5000);
      authApi.me().then(({ user }) => {
        if (user) {
          setUser(user);
          localStorage.setItem('flare_user', JSON.stringify(user));
        }
      }).catch(() => {
        authApi.logout();
        setUser(null);
      }).finally(() => {
        clearTimeout(timer);
        finish();
      });
      return () => clearTimeout(timer);
    }
    setLoading(false);
    return undefined;
  }, []);

  const login = useCallback(async (email, password, remember = true) => {
    const result = await authApi.login(email, password, remember);
    setUser(result.user);
    return result;
  }, []);

  const logout = useCallback(async () => {
    await authApi.logout();
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}

export default AuthContext;
